const initialState = {
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 50,
      name__icontains: '',
      ordering: '-created_at',
    },
    data: {
      items: [],
      count: 0,
    },
  },
  add: {
    isLoading: false,
    error: '',
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
